<ion-header mode="ios">
    <ion-toolbar>
        <ion-button slot="start" fill="clear" color="dark" (click)="onCancel()">Cancel</ion-button>
        <ion-title class="title">{{editMode ? 'Edit Check In' : 'Visit Details'}}</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <div sxCol sxPadding="medium" sxGap="5px">

        <!-- Check In Section -->


        <div sxRow sxAlign="end" sxWidth="fill">
            <!-- Check In Date Input -->
            <super-input label="Check-In" class="w-[55%]" type="date" [(value)]="checkoutData.checkInDate"
                [required]="true" (valueChange)="onCheckInDateChange()">
            </super-input>

            <!-- Check In Time Input -->
            <super-input type="time" [(value)]="checkoutData.checkInTime" class="w-[45%]" [required]="true">
            </super-input>
        </div>


        <!-- Check Out Section -->
        <div *ngIf="!editMode" sxRow sxAlign="end" sxWidth="fill">
            <!-- Check Out Date Input -->
            <super-input label="Check-Out" class="w-[55%]" type="date" [(value)]="checkoutData.checkOutDate"
                [required]="true">
            </super-input>

            <!-- Check Out Time Input -->
            <super-input type="time" [(value)]="checkoutData.checkOutTime" class="w-[45%]" [required]="true">
            </super-input>
        </div>


        <!-- Remark -->
        <super-input *ngIf="!editMode" label="Remark" type="text" [(value)]="checkoutData.remark"
            placeholder="Enter any additional remarks">
        </super-input>

        <div *ngIf="!editMode && timeConfigReady" sxBackground="light" sxRadius="medium" sxBorderColor="one" sxBorderWidth="1px"
            sxMargin="20px 0 0">
            <div sxRow sxAlign="start" sxGap="10px" sxPadding="medium">
                <div sxCol sxGap="5px">
                    <p sxMargin="0" sxTextSize="small" sxTextWeight="bold" sxColor="three">Submit to TIME</p>
                    <p sxMargin="0" sxTextSize="small" sxColor="two">Details are required as per Form XI - Statistics
                        Proforma.</p>
                </div>
                <ion-toggle sxMargin="10px 0 0" mode="md" [(ngModel)]="checkoutData.submitToTimes" [checked]="true">
                </ion-toggle>
            </div>

            <time-integration #timeIntegration [share]="share" [submitToTimes]="checkoutData.submitToTimes"
                [checkInDate]="checkoutData.checkInDate" [checkOutDate]="checkoutData.checkOutDate">
            </time-integration>
        </div>






        <div sxMargin="10px 0 0 0">
            <super-button [showError]="true" [action]="onSubmit" iconEnd="chevron-forward-outline">{{editMode ? 'Update' : 'Submit'}}</super-button>
        </div>


    </div>
</ion-content>